<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <v-btn color="#000" icon class="ml-n4 mr-3" @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <span class="title">Alerta de data de negociação</span>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pa-0 px-4 pt-6 pb-4">
          <div style="font-size: 15px" class="d-flex">
            <v-icon left class="mt-n4">mdi-alert</v-icon>
            <p v-if="diaDataLimite > 0">
              Falta{{ parseInt(diaDataLimite) > 1 ? 'm' : ''}} {{ diaDataLimite }} dia{{ parseInt(diaDataLimite) > 1 ? 's' : ''}} para a data limite de negociação com o fornecedor
            </p>
            <p v-else-if="diaDataLimite === 0">Último dia para negociação com o fornecedor é hoje</p>
            <p v-else>
              Data limite de negociação com o fornecedor expirada a {{ Math.abs(diaDataLimite) }} dia{{ parseInt(Math.abs(diaDataLimite)) > 1 ? 's' : ''}}
            </p>
          </div>
        </v-card-text>

        <v-card-actions style="margin-top: -10px">
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CompraAPI from "../../../api/compra";
import {mapGetters} from "vuex";

export default {
  name: "DialogAlertaDataLimite",
  data: () => ({
    dialog: false,
    diaDataLimite: null
  }),
  computed: {
    ...mapGetters({
      fornecedor: "fornecedor/getFornecedor",
    }),
  },
  created() {
    this.buscarDataLimiteFornecedor();
  },
  methods: {
    buscarDataLimiteFornecedor () {
      const headers = this.Helpers.iniciarRequisicao();

      const params = { fornecedor: this.fornecedor.id };

      this.$store.dispatch(
        "loading/addRequisicao",
        CompraAPI.getDataLimiteFornecedor(headers, params)
          .then((response) => {
            const {token, dia_data_limite} = response.data;
            localStorage.setItem("token", token);

            if(parseInt(dia_data_limite) <= 2) {
              this.dialog = true
              this.diaDataLimite = dia_data_limite
            }
          })
          .catch(() => {
            this.Helpers.logout();
          })
      )
    },
  }
}
</script>

<style scoped>

</style>
